module.exports = __webpack_public_path__ + "img/noSearchResult.c10997d0.svg";